import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import './index.less'

const ReviewsVideo = ({ sectionId }) => {
  const rootRef = useRef(null)
  const swiperElRef = useRef(null)
  const swiperRef = useRef(null)

  const resetDeferredMediaInSlide = (slideEl) => {
    if (!slideEl) return
    const deferred = slideEl.querySelectorAll('deferred-media[loaded]')
    deferred.forEach((dm) => {
      dm.removeAttribute('loaded')
      dm.querySelectorAll('iframe, video, model-viewer').forEach((node) => node.remove())
    })
  }

  const pauseVideosInSlide = (slideEl) => {
    if (!slideEl) return
    slideEl.querySelectorAll('video').forEach((v) => {
      try {
        v.pause()
      } catch (_) {}
      try {
        v.currentTime = 0
      } catch (_) {}
    })
  }

  const normalizeActiveSlide = (activeIndex) => {
    const swiper = swiperRef.current
    if (!swiper) return

    swiper.slides.forEach((slide, index) => {
      if (index === activeIndex) return
      pauseVideosInSlide(slide)
      resetDeferredMediaInSlide(slide)
    })
  }

  useEffect(() => {
    rootRef.current = document.querySelector(`reviews-video[section-id="${sectionId}"]`)
    if (!rootRef.current) return

    swiperElRef.current = rootRef.current.querySelector('.reviews-video__swiper.swiper')
  }, [])

  useEffect(() => {
    if (!swiperElRef.current) return
    if (!window?.XBLOOM3?.Swiper) return

    const Swiper = window.XBLOOM3.Swiper

    swiperRef.current = new Swiper(swiperElRef.current, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,
      speed: 400,
      watchSlidesProgress: true,
      on: {
        init: function () {
          normalizeActiveSlide(this.activeIndex)
        },
        slideChange: function () {
          normalizeActiveSlide(this.activeIndex)
        },
      },
      breakpoints: {
        0: {
          spaceBetween: 8,
        },
        750: {
          spaceBetween: 40,
        },
      },
    })

    // CTA button on each slide advances swiper
    const onCtaClick = (event) => {
      const btn = event.target.closest('.reviews-video__cta')
      if (!btn) return
      swiperRef.current?.slideNext?.()
    }
    rootRef.current.addEventListener('click', onCtaClick)

    return () => {
      rootRef.current?.removeEventListener('click', onCtaClick)
      try {
        swiperRef.current?.destroy?.(true, true)
      } catch (_) {}
    }
  }, [sectionId])

  return <div />
}

window.XBLOOM3.DefineXbloomSectionReactComponent('reviews-video', ReviewsVideo, ReactDOM)

